import script from "./Level4Instructions.vue?vue&type=script&setup=true&lang=js"
export * from "./Level4Instructions.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__